import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const CompanyRootElement = styled.div`
    width: 100%;
    .project-section {
        padding-top: 64px;
        padding-bottom: 64px;
        background: #fff;
        .MuiTypography-headline-large {
            font-size: 26px;
        }
        @media (max-width: 767px) {
            padding-top: 48px;
            padding-bottom: 48px;
            .MuiTypography-headline-large {
                margin-bottom: 18px;
            }
        }
    }
    .story-page-container {
        max-width: 864px;
        margin: 0 auto;
        padding: 0px 1em;
    }
    .project-summary {
        display: flex;
        gap: 24px;
        margin-bottom: 32px;
        @media (max-width: 767px) {
            flex-direction: column;
        }
        .MuiTypography-headline-medium {
            font-size: 21px;
            margin-bottom: 16px;
            display: block;
        }
        ul {
            margin: 0;
            padding: 0;
            list-style: none;
            width: 25%;
            @media (max-width: 767px) {
                width: 100%;
            }
            p {
                font-size: 1.313rem;
            }
            li {
                padding: 12px 0;
                box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1) inset;
                &:last-child: {
                    box-shadow: none;
                }
            }
        }
    }
    .back-button {
        padding: 0;
        text-transform: none;
        font-size: ${styleVariables.primitivesFontSize['3']};
        &:hover {
            background: none;
        }
    }
`;
export default CompanyRootElement;
